import mixpanel from 'mixpanel-browser'
import { isMixpanelInitialized } from './initMixpanel'
import type { User } from '../../types'

let lastUserKey: string | null = null

export function setMixpanelUserProperties(user: User | null | undefined): void {
  if (!isMixpanelInitialized() || !user) {
    return
  }

  const trainingEventStartDate = user.trainingEventStartDate as string | undefined
  const trainingEventEndDate = user.trainingEventEndDate as string | undefined
  const trainingEventProgramTitle = user.trainingEventProgramTitle as string | undefined
  const trainingEventInstructorSfid = user.trainingEventInstructorSfid as string | undefined
  const trainingEventTrialStartDate = user.trainingEventTrialStartDate as string | undefined
  const appUserCategory = user.appUserCategory as string | undefined
  const subscriptionCurrentPeriodStart = user.subscriptionCurrentPeriodStart as string | undefined
  const subscriptionCurrentPeriodEnd = user.subscriptionCurrentPeriodEnd as string | undefined
  const subscriptionCreatedAt = user.subscriptionCreatedAt as string | undefined
  const properties: Record<string, unknown> = {}

  if (trainingEventStartDate) {
    properties.training_event_start_date = trainingEventStartDate
  }

  if (trainingEventEndDate) {
    properties.training_event_end_date = trainingEventEndDate
  }

  if (trainingEventProgramTitle) {
    properties.training_event_program_title = trainingEventProgramTitle
  }

  if (trainingEventInstructorSfid) {
    properties.training_event_instructor_sfid = trainingEventInstructorSfid
  }

  if (trainingEventTrialStartDate) {
    properties.training_event_trial_start_date = trainingEventTrialStartDate
  }

  if (appUserCategory) {
    properties.app_user_category = appUserCategory
  }

  if (subscriptionCurrentPeriodStart) {
    properties.subscription_current_period_start = subscriptionCurrentPeriodStart
  }

  if (subscriptionCurrentPeriodEnd) {
    properties.subscription_current_period_end = subscriptionCurrentPeriodEnd
  }

  if (subscriptionCreatedAt) {
    properties.subscription_created_at = subscriptionCreatedAt
  }

  // Subscription properties
  const subscriptionStatus = (user as any).subscriptionStatus as string | undefined
  const subscriptionTier = (user as any).subscriptionTier as string | undefined
  const isProsciCertified = (user as any).isProsciCertified as boolean | undefined
  const billingCountry = (user as any).billingCountry as string | undefined

  if (subscriptionStatus) properties.subscription_status = subscriptionStatus
  if (subscriptionTier) properties.subscription_tier = subscriptionTier
  if (isProsciCertified !== undefined) properties.is_certified = isProsciCertified
  if (billingCountry) properties.billing_country = billingCountry

  // Signup flow V2 properties
  const signupMetadata = (user as any).signupMetadata as Record<string, unknown> | undefined
  if (signupMetadata) {
    if (signupMetadata.role) properties.signup_role = signupMetadata.role
    if (signupMetadata.useCases || signupMetadata.use_cases) properties.signup_use_cases = signupMetadata.useCases || signupMetadata.use_cases
    if ((signupMetadata.onboardingCompleted ?? signupMetadata.onboarding_completed) !== undefined) properties.onboarding_completed = signupMetadata.onboardingCompleted ?? signupMetadata.onboarding_completed
    if (signupMetadata.signupSource || signupMetadata.signup_source) properties.signup_source = signupMetadata.signupSource || signupMetadata.signup_source
    if (signupMetadata.wizardCompletedAt || signupMetadata.wizard_completed_at) properties.signup_date = signupMetadata.wizardCompletedAt || signupMetadata.wizard_completed_at
    if ((signupMetadata.selectedTier || signupMetadata.selected_tier) && !subscriptionTier) properties.subscription_tier = signupMetadata.selectedTier || signupMetadata.selected_tier
  }

  if (Object.keys(properties).length === 0) {
    return
  }

  const signupKey = signupMetadata ? JSON.stringify(signupMetadata) : ''
  const userKey = `${user.id}:${trainingEventStartDate || ''}:${trainingEventEndDate || ''}:${trainingEventProgramTitle || ''}:${trainingEventInstructorSfid || ''}:${trainingEventTrialStartDate || ''}:${appUserCategory || ''}:${subscriptionCurrentPeriodStart || ''}:${subscriptionCurrentPeriodEnd || ''}:${subscriptionCreatedAt || ''}:${signupKey}`
  if (userKey === lastUserKey) {
    return
  }

  lastUserKey = userKey
  mixpanel.identify(user.id)
  mixpanel.people.set(properties)
}

